export default __webpack_public_path__ + "static/media/5.c0dd7a31.png";